import React from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';

const AlertMessage = ({ type = 'info', message }) => {
  const icon =
    type === 'success' ? <CheckCircle className="w-5 h-5 mr-2 text-emerald-500" /> :
    type === 'error' ? <AlertCircle className="w-5 h-5 mr-2 text-red-500" /> : 
    <AlertCircle className="w-5 h-5 mr-2 text-blue-500" />;

  const bgColor =
    type === 'success' ? 'bg-emerald-50 text-emerald-800' :
    type === 'error' ? 'bg-red-50 text-red-800' : 
    'bg-blue-50 text-blue-800';

  return (
    <div className={`flex items-center p-4 rounded-lg ${bgColor}`}>
      {icon}
      <span>{message}</span>
    </div>
  );
};

export default AlertMessage;
